import classNames from 'volta/helpers/class-names';
import BvTooltip from 'volta/components/bv-tooltip';
import BaseCell from './base-cell';
import { concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import isBefore from 'ember-moment/helpers/is-before';
import isSame from 'ember-moment/helpers/is-same';
import momentFormat from 'ember-moment/helpers/moment-format';
import utc from 'ember-moment/helpers/utc';
import and from 'ember-truth-helpers/helpers/and';

import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CellDueDateCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellDueDateCellComponent = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <BaseCell
    @cell={{@cell}}
    @row={{@row}}
    @column={{@column}}
    @scrollToRow={{@scrollToRow}}
    class='u-d-flex u-align-items-center due-date-cell-edit'
    as |baseCell|
  >
    {{#let (utc baseCell.model.dueDate) as |dateToDisplay|}}
      <div
        class={{classNames
          'ember-table-content u-d-flex u-align-items-center'
          (if (isSame (utc) dateToDisplay precision='day') 'u-color-severe')
          (if (isBefore dateToDisplay (utc) precision='day') 'u-color-danger')
        }}
      >
        {{momentFormat dateToDisplay 'L' timeZone='UTC'}}
      </div>
    {{/let}}
    {{#if (and baseCell.model.deliveryDate baseCell.model.isDemand)}}
      <BvTooltip
        @text={{concat
          (t 'deliveryDate')
          ': '
          (momentFormat (utc baseCell.model.deliveryDate) 'L' timeZone='UTC')
        }}
      />
    {{/if}}
  </BaseCell>
</template> satisfies TemplateOnlyComponent<CellDueDateCellSignature>;

export default CellDueDateCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::DueDateCell': typeof CellDueDateCellComponent;
    'cell/due-date-cell': typeof CellDueDateCellComponent;
  }
}
